import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../common/components";
import './filter-options-text.scss';

const LastNameFilter: any = (
  props: any
) => {
  const { lastName, handleLastNameChange, isLastNameEnabled, lastNameError } = props
  useEffect(() => {
    if (!isLastNameEnabled) {
      handleLastNameChange({ target: { value: "", name: "lastName" } } as any, "lastName");
    }
  }, [isLastNameEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          lastName: lastName,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="lastName"
            placeholder="Enter Last Name"
            optional={false}
            disabled={false}
            value={lastName}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleLastNameChange(e, "lastName")
            }
          />
          {lastNameError && <div className="error-text">{lastNameError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default LastNameFilter;